export default __webpack_public_path__ + "static/9-ece5210bc5a718719a6ef4dfe92d61d4.webp";